import type { AfterViewInit } from '@angular/core';
import {
  Component,
  effect,
  inject,
  Injector,
  input,
  viewChild,
} from '@angular/core';
import {
  OnyxAddressComponent,
  OnyxIconButtonComponent,
  OnyxInformationListComponent,
  OnyxInformationRowComponent,
  OnyxMapComponent,
  OnyxMapEvent,
  OnyxMapMarkerType,
} from '@onyx/angular';
import { PointOfInterestHelper } from '../../../points-of-interest/common/helpers/point-of-interest.helper';
import type { SimplifiedPointOfInterest } from '../../../points-of-interest/common/interfaces/point-of-interest';
import type { Contractor } from '../../common/interfaces/contractor';

@Component({
  selector: 'app-contractor-modal-points-of-interest',
  imports: [
    OnyxMapComponent,
    OnyxInformationRowComponent,
    OnyxAddressComponent,
    OnyxInformationListComponent,
    OnyxIconButtonComponent,
  ],
  templateUrl: './contractor-modal-points-of-interest.component.html',
  styleUrl: './contractor-modal-points-of-interest.component.scss',
})
export class ContractorModalPointsOfInterestComponent implements AfterViewInit {
  private readonly injector = inject(Injector);
  private readonly pointOfInterestHelper = inject(PointOfInterestHelper);

  public readonly contractor = input.required<Contractor>();

  private readonly map = viewChild.required(OnyxMapComponent);

  public ngAfterViewInit(): void {
    effect(
      () => {
        const points = this.contractor().pointsOfInterest.map(
          ({ pointOfInterest }) => ({
            id: pointOfInterest.uuid,
            type: OnyxMapMarkerType.POINT_OF_INTEREST,
            coordinates: pointOfInterest.address.coordinates,
          }),
        );

        const drawnMarkers = new Set<string>();
        for (const { id, coordinates, type } of points) {
          this.map().dispatch(
            new OnyxMapEvent.AddUpdateMarker({ id, type, coordinates }),
          );
          drawnMarkers.add(id);
        }

        for (const id of this.map().markers) {
          if (drawnMarkers.has(id)) continue;
          this.map().dispatch(new OnyxMapEvent.RemoveMarker({ id }));
        }

        this.map().dispatch(new OnyxMapEvent.FitContent());
      },
      { injector: this.injector },
    );
  }

  protected openModal(pointOfInterest: SimplifiedPointOfInterest): void {
    this.pointOfInterestHelper.openModal(pointOfInterest);
  }
}
